import { hbs } from 'ember-cli-htmlbars';
export default hbs("<NwSiteAuditPage @model={{this.model}} />")